import { BehaviorSubject } from 'rxjs';

const currentUser = {
    usuario: "",
    roles: []
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
    signin,
    signout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
};

function signin(username) {
    var admins = ["sbrodrig", "marfzuri", "jrodrig", "abernabe", "slopez", "josasanc"];
    let rolesA = [];
    if (admins.includes(username)) {
        rolesA.push("ADMIN");
    }

    let signinUser = {
        usuario: username,
        roles: rolesA
    };

    console.log("signinUser: ", signinUser);
    currentUserSubject.next(signinUser);

    // AQUI TIENE QUE IR LLAMADA AL API PARA OBTENER INFORMACION DEL ALUMNI
    //fetch("/api/Auth/Login", { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username: username }) })
    //    .then(response => response.json())
    //    .then(data => {
    //        if (data && data.username == username) {
    //            let signinUser = {
    //                usuario: data.username,
    //                roles: data.roles
    //            };

    //            currentUserSubject.next(signinUser);
    //        }
    //    });
}

function signout() {
    // remove user and go to logout CAS
    currentUserSubject.next(null);
}


